import configuration from './configuration'
import Zone from './Zone'
import SceneController from './SceneController'
const THREE = window.THREE

export default {
  unitsToPixels (units, objectType) {
    if (objectType === 'pointer') return units * 125
    return units * 3075
  },
  indexRoutes (routes) {
    let acc = {}
    routes.forEach(route => indexRoute(route, acc))
    return acc
  },
  getCenterPoint (mesh) {
    let middle = new THREE.Vector3()
    let geometry = mesh.geometry

    geometry.computeBoundingBox()

    middle.x = (geometry.boundingBox.max.x + geometry.boundingBox.min.x) / 2
    middle.y = (geometry.boundingBox.max.y + geometry.boundingBox.min.y) / 2
    middle.z = (geometry.boundingBox.max.z + geometry.boundingBox.min.z) / 2

    mesh.localToWorld(middle)
    return middle
  },
  applyCustomPropertiesToObject (object, THREE, props, scene) {
    let groupName = object.name.split('_')[0]
    let customProperties = props[groupName]
    if (customProperties) {
      let keys = Object.keys(customProperties)
      keys.forEach(key => {
        let val = customProperties[key]
        switch (key) {
          case 'video':
            object.material.visible = false
            var video = document.createElement('video')
            // video.src = './static/img/7_DOUBLE_DUTCH/7.5/oude_vlag_05_1.mp4'
            video.src = val
            video.load()
            video.loop = true
            // video.muted = true
            // video.play()
            if (!window.videos) {
              window.videos = {}
            }
            window.videos[object.name.split('sprite-')[1].split('_')[0]] = video
            var texture = new THREE.VideoTexture(video)
            texture.minFilter = THREE.LinearFilter
            texture.magFilter = THREE.LinearFilter
            texture.format = THREE.RGBFormat
            var movieMaterial = new THREE.MeshBasicMaterial({
              color: 0xffffff,
              map: texture
            })
            let movieScreen
            if (keys.indexOf('customRatio') !== -1) {
              const width = customProperties['width']
              const height = customProperties['height']
              const movieGeometry = new THREE.PlaneGeometry(width * 0.4, height * 0.4, 1, 1)
              movieScreen = new THREE.Mesh(movieGeometry, movieMaterial)
            } else {
              const movieGeometry = new THREE.PlaneGeometry(16 * 0.4, 9 * 0.4, 1, 1)
              movieScreen = new THREE.Mesh(movieGeometry, movieMaterial)
            }
            var position = this.getCenterPoint(object, THREE)
            movieScreen.position.set(position.x, position.y, position.z)
            scene.add(movieScreen)
            break
          case 'material':
            switch (val) {
              case 'basic':
                let color = object.material.color.getHex()
                let side = object.material.side
                let map = object.material.map
                let transparent = object.material.transparent
                // console.log('basic', object, color)
                object.material = new THREE.MeshBasicMaterial({
                  color,
                  side,
                  map,
                  transparent
                })
                break
            }
            break
          case 'side':
            switch (val) {
              case 'double':
                object.material.side = 2
                break
            }
            break
          case 'color':
            object.material.color.setHex(parseInt(val, 16))
            break
          default:
            object[key] = val
            // console.log('default', object, key, val)
            break
        }
      })
    }
  },
  traverseObject (object, customProperties, ctx, cursorsObject) {
    // console.log('traversing ', object, ctx)
    object.traverse(child => {
      if (child.name.indexOf('zone-') === 0) {
        this.handleZone(child, ctx)
      }
      if (child.name.indexOf('toPosition-') === 0) {
        this.handleToPosition(child, ctx)
      }
      if (child.name.indexOf('outline-') === 0) {
        this.handleOutline(child, ctx)
      }
      if (child.name.indexOf('background-') === 0) {
        this.handleBackground(child, ctx)
      }
      if (child.name.indexOf('sprite-') === 0) {
        this.handleSprite(child, ctx)
      }
      if (child.name.indexOf('arrow-') === 0) {
        this.handleArrow(child, ctx)
      }
      if (child.name.indexOf('pointer-') === 0) {
        this.handlePointer(child, ctx)
      }
      if (child.name.indexOf('title-') === 0) {
        this.handleTitle(child, ctx)
      }
      if (child.name.indexOf('intro-') === 0) {
        this.handleIntro(child, ctx)
      }
      if (child.name.indexOf('cursor-') === 0) {
        this.handleCursor(child, cursorsObject)
      }
      if (child.name.indexOf('cursorWindow') === 0) {
        this.handleCursorWindow(child, cursorsObject)
      }
      if (child.material) {
        if (child.material.map) {
          child.material = new THREE.MeshBasicMaterial({
            map: child.material.map,
            color: 0xffffff,
            transparent: true
          })
        }
      }
      this.applyCustomPropertiesToObject(
        child,
        THREE,
        customProperties,
        object)

      if (configuration.renderOrder[child.name]) {
        child.renderOrder = configuration.renderOrder[child.name]
      }
    })
  },
  handleArrow (object, ctx) {
    let index = /arrow-([0-9]*)/.exec(object.name)[1]
    object.zoneIndex = index
    object.material = new THREE.MeshBasicMaterial({color: 0xeeeeee})
    ctx.arrows[index] = object
  },
  handleBackground (object, ctx) {
    let name = /background-([a-zA-Z]*)/.exec(object.name)[1]
    object.material.transparent = true
    if (configuration.renderOrder[name]) {
      object.renderOrder = configuration.renderOrder[name]
    }
    ctx.backgrounds[name] = object
  },
  handleCursor (object, cursorsObject) {
    let name = /^[a-zA-z]*-([a-zA-Z]*)_/.exec(object.name)[1]
    if (name === 'zoomIn' || name === 'zoomOut') {
      object.rotation.x = 0.3
    }
    object.material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      visible: false,
      side: THREE.DoubleSide
    })
    if (cursorsObject) {
      cursorsObject.cursors[name] = object
    }
  },
  handleCursorWindow (object, cursorsObject) {
    object.material = new THREE.MeshBasicMaterial({
      visible: false
    })
    if (cursorsObject) {
      cursorsObject.cursorWindow = object
    }
  },
  handleIntro (object, ctx) {
    let key = /^[a-zA-z]*-([a-zA-Z0-9.-]*)_/.exec(object.name)[1]
    object.material = new THREE.MeshBasicMaterial({
      visible: false
    })
    ctx.intros[key] = object
  },
  handlePointer (object, ctx) {
    let key = /^[a-zA-z]*-([a-zA-Z0-9.-]*)_/.exec(object.name)[1]
    ctx.pointers[key] = object
    object.material = new THREE.MeshBasicMaterial({
      visible: false
    })
  },
  handleSprite (object) {
    object.material.transparent = true
  },
  handleTitle (object, ctx) {
    let key = /^[a-zA-z]*-([a-zA-Z0-9.-]*)_/.exec(object.name)[1]
    ctx.titles[key] = object
    object.material = new THREE.MeshBasicMaterial({
      visible: false
    })
  },
  handleToPosition (object, ctx) {
    let index = /toPosition-([0-9a-zA-Z.-]*)_/.exec(object.name)[1]
    object.material = new THREE.MeshBasicMaterial({
      visible: false
    })
    object.material.visible = false
    ctx.toPositions[index] = object
  },
  handleOutline (object, ctx) {
    let index = /outline-([0-9a-zA-Z.-]*)_/.exec(object.name)[1]
    object.material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      visible: false,
      side: THREE.DoubleSide
    })
    ctx.outlines[index] = object
  },
  cleanChapterIndex (index) {
    if (index.toString().indexOf('.001') !== -1) return index.split('.001')[0]
    return index
  },
  handleZone (object, ctx) {
    let zone = new Zone(object)
    ctx.zones[zone.zoneIndex] = zone
  },
  parseChapters (chapters, $bus) {
    return chapters.reduce((acc, val, i) => {
      let chapterCopy = Object.assign({}, val)
      let chapterIndex = i + 1
      chapterCopy.subChapters = chapterCopy.subChapters.reduce((acc, val, i) => {
        let subChapterIndex = i + 1
        acc[chapterIndex + '.' + subChapterIndex] = val
        return acc
      }, {})
      let chapter = new SceneController(chapterIndex, chapterCopy, $bus)
      acc[chapterIndex] = chapter
      return acc
    }, {})
  },
  parseIndexChapter (chapters) {
    return chapters.reduce((acc, val, i) => {
      acc[val.key] = {
        title: val.title,
        intro: val.intro
      }
      return acc
    }, {})
  }
}

let indexRoute = (route, acc) => {
  if (route.meta && typeof route.meta.zoneIndex !== 'undefined') {
    acc[route.meta.zoneIndex] = route
  }
  if (route.children) {
    route.children.forEach(child => indexRoute(child, acc))
  }
}



// WEBPACK FOOTER //
// ./src/world/WorldUtils.js